module.exports = __webpack_public_path__ + "portal-static/img/video_img.f3143604.png";